module.exports = __webpack_public_path__ + "img/sombra.e008c79b.png";